export const izjava_o_odricanju_od_otkaznog_roka = {
  templateId: 18,
  category: 1,
  templateTitle: "Izjava o odricanju od otkaznog roka",
  templateDescription: `Na redovite otkaze koje je uputio poslodavac primjenjuju se otkazni rokovi, no radnik se može odreći navedenog vlastitog prava na otkazni rok.`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Otkazni rok predstavlja propisani protek vremena (najkraći otkazni rokovi su propisani Zakonom o radu), nakon isteka kojega nastupaju učinci otkaza ugovora o radu.</p> 
    <p> U slučaju kad radnik dobiva redoviti otkaz (kod izvanrednog otkaza nema otkaznog roka), otkazni rok se smatra zaštitnom instrumentom u korist radnika, npr. radi omogućavanja pronalaska novog posla i sl..</p> 
    <p>Radnik se nakon primitka redovitog otkaza ugovora u radu može odreći prava na otkazni rok, jer je to pravo u trenutku primitka otkaza dospjelo. Odricanje prava na otkazni rok nakon početka ili pak tijekom trajanja otkaznog roka ima za pravnu posljedicu prestanak ugovora o radu u trenutku kad je odricanje radnika od prava na otkazni rok dostavljeno poslodavcu (rješenje Vrhovnog suda Republike Hrvatske, Rev 950/1999. od 17. listopada 1999.)</p>         
    <p><strong>Dakle, da bi odricanje od otkaznog roka od strane radnika nakon što mu je poslodavac dao otkaz bilo valjano, otkazni rok radnika mora početi teći (otkazni rok počinje teći nakon uručenja otkaza).</strong></p> 
    <strong>U tom slučaju, ukoliko se radnik želi odreći otkaznog roka, radni odnos bi prestao u trenutku kad poslodavac primi izjavu radnika o odricanju od otkaznog roka.</strong></p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu.</p>
  `,
  
  sides: [
  {
    prefix: "Na temelju Zakona o radu,",
    signature: "Radnik:",
  	inputs:[{ 
      type: "input", 
      required: true, 
      placeholder: "Ime i prezime",
      label: "Ime i prezime",
      inSignature: true,
    },
    { 
      type: "input", 
      required: true, 
      placeholder: "Ulica i kućni broj",
    },
    { 
      type: "input", 
      required: true, 
      placeholder: "Mjesto",
    },
    { 
      type: "input", 
      required: true, 
      placeholder: "OIB",
    },
    ],
    suffix: " (u daljnjem tekstu: Radnik),"
  }
  ],
    
  headline: "upućuje sljedeću",
  title: "IZJAVU",

  noArticleNumbers: true,

  articles: [
  {
    title: "",
    mandatory: true,
    statements: [
    {
      type: "input",
      mandatory: true,
      editable: false,
      parts: [
        { type: "text", content: "kojom ja, gore navedeni, izjavljujem da se odričem prava na otkazni rok u trajanju od" },
        { type: "input",  required: true, placeholder: "Unesite trajanje otk. roka" },
        { type: "text", content: "navedenog u točki " },
        { type: "input",  required: true },
        { type: "text", content: "Odluke o otkazu donesene od strane Poslodavca " },
        { type: "input",  required: true, placeholder: "Unesite naziv poslodavca" },
        { type: "text", content: ", dana" },
        { type: "input",  required: true },
        { type: "text", content: "godine." },
      ],
      value:"",
    }]
  },
  {
    title: "",
    mandatory: false,
    statements: [
      {
        type: "text",
        mandatory: true,
        editable: true,
        content: "U tom smislu predlažem da mi radni odnos prestane u trenutku kad Poslodavac primi ovu Izjavu."
      }]
  },
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
  {
    mandatory: true,
    static: true,
    type: 3,  // signatures   
    statements: [],
  },
  {
    static: true,
    mandatory: true,
    editable: true,
    type: 4, 
    statements: [
      {
        type: "text",
        mandatory: true,
        editable: true,
        help: "Otkazni rok počinje teći uručenjem otkaza poslodavcu.",
        content: "\r\nPoslodavac svojim potpisom potvrđuje primitak Izjave dana ________________ godine.\r\n\r\nZa Poslodavca: ________________________. "
        },
      ],
    },
],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/18_izjava_o_odricanju_od_otkaznog_roka.ts